export default __webpack_public_path__ + "static/media/alertIcon.a535e3a4.svg";